"use client";
import { jsx } from "react/jsx-runtime";
import { Skeleton } from "@nxt-costco-com/forge-components";
import { ColorGray600 } from "@nxt-costco-com/forge-design-tokens";
import { useCheckScreen } from "../../../../../hooks/useCheckScreen/index.js";
const VideoSpotlightSkeleton = ({
  variant
}) => {
  const { isMobile } = useCheckScreen();
  return /* @__PURE__ */ jsx(
    Skeleton,
    {
      sx: {
        border: `1px solid`,
        borderColor: ColorGray600,
        borderRadius: "10px",
        display: "flex",
        flex: 1,
        flexDirection: isMobile || variant === "rail" ? "column" : "row",
        height: isMobile || variant === "rail" ? "753px" : "250px",
        width: isMobile || variant === "rail" ? "330px" : { lg: "1024px", md: "768px" }
      },
      "data-testid": "video_spotlight_skeleton"
    }
  );
};
export {
  VideoSpotlightSkeleton
};
